import React from 'react';
import PortfolioTitle from '../../Utilities/PortfolioTitle'

// material
import Grid from '@material-ui/core/Grid'

// Images
import BlockChainImg from '../../../assets/portfolio/BlockChain/IconBlockChain.png'

export default class BlockChain extends React.Component{
 render(){
  return(
    <section>
      <div className="container PortfolioItem" style={{marginBottom: 80, }}>
        <Grid container alignItems="flex-center">
          <Grid item className="AppDevelopmentImage">
          <img style={{maxHeight: 80}} src={BlockChainImg} alt=""/>
          </Grid>
          <Grid item>
          <PortfolioTitle colorTitle="white" colorSubtitle="white" title="BlockChain" subtitle="Consulting and development smart contracts and tokens"/>
          </Grid>
        </Grid>
      </div>
    </section>
  );
 }
}


// WEBPACK FOOTER //
// ./src/Components/Portfolio/BlockChain/BlockChain.js